import React from 'react';

function BottomNav({ active }) {
    const go = (hash) => {
        window.location.hash = hash;
    };
    const item = (key, label, hash) => (
        <button
            className={`flex-1 py-3 ${active === key ? 'text-blue-600 font-semibold' : 'text-gray-700'}`}
            onClick={() => go(hash)}
        >
            {label}
        </button>
    );

    return (
        <div className="fixed inset-x-0 bottom-0 border-t bg-white flex h-16">
            {item('events', 'Events', '#/events')}
            {item('campaigns', 'Campaigns', '#/campaigns')}
        </div>
    );
}

export default BottomNav;


